(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
